import sanitizeHtml from "sanitize-html";

const ALLOWED_TAGS = [
  // Block elements
  "div",
  "p",
  "section",
  "header",
  "footer",
  "nav",
  "article",
  "figure",
  "figcaption",
  "blockquote",
  "pre",
  "hr",
  "br",
  // Headings
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  // Inline elements
  "span",
  "a",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "code",
  "small",
  "sub",
  "sup",
  // Lists
  "ul",
  "ol",
  "li",
  // Tables
  "table",
  "thead",
  "tbody",
  "tfoot",
  "tr",
  "td",
  "th",
  "caption",
  "colgroup",
  "col",
  // Media
  "img",
];

const STYLE_AND_CLASS = ["style", "class"];

export const sanitizePortalHTMLContent = (html: string) =>
  sanitizeHtml(html, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: {
      "*": STYLE_AND_CLASS,
      a: ["href", "target", "rel", ...STYLE_AND_CLASS],
      img: ["src", "alt", "width", "height", ...STYLE_AND_CLASS],
      td: ["colspan", "rowspan", ...STYLE_AND_CLASS],
      th: ["colspan", "rowspan", "scope", ...STYLE_AND_CLASS],
      col: ["span", ...STYLE_AND_CLASS],
      colgroup: ["span", ...STYLE_AND_CLASS],
    },
    transformTags: {
      a: (tagName, attribs) => {
        const href = attribs.href || "";
        if (href.startsWith("http://") || href.startsWith("https://")) {
          return {
            tagName,
            attribs: {
              ...attribs,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          };
        }
        return { tagName, attribs };
      },
    },
    allowedSchemesByTag: {
      img: ["http", "https", "data"],
      a: ["http", "https", "mailto", "tel"],
    },
  });
